import { PointsLabel } from "@/modules/theme/components/PointsLabel";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createUndoneSubtaskStyles } from "./createUndoneSubtaskStyles";

export type UndoneSubtaskProps = {
  id: string;
  name: string;
  pointsNumber: number;
};

export const UndoneSubtask = ({ name, pointsNumber }: UndoneSubtaskProps) => {
  const classes = createUndoneSubtaskStyles(useTheme());
  return (
    <div className={classes.root}>
      <p className={classes.name}>{name}</p>
      <PointsLabel points={pointsNumber} className={classes.points} />
    </div>
  );
};
